
//import create from 'zustand';
import { create } from "zustand";

export type TreeWindow = {
  winId: string;
  skillId: string;
  x: number;
  y: number;
  w: number;
  h: number;
  z: number;
  highlightId?: string;
};

interface SkillsState {
  windows: TreeWindow[];
  openWindow: (skillId: string, highlightId?: string) => void;
  closeWindow: (winId: string) => void;
  bringToFront: (winId: string) => void;
  moveWindow: (winId: string, x: number, y: number) => void;
  resizeWindow: (winId: string, w: number, h: number) => void;

  openSkillId: string | null;
  setOpenSkillId: (id: string | null) => void;

  query: string;
  setQuery: (q: string) => void;
}

let zCounter = 10;
let cascade = 40;

const useSkillsStore = create<SkillsState>((set, get) => ({
  windows: [],
  openWindow: (skillId, highlightId) => {
    const next = get().windows.slice();
    const winId = `${skillId}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    const offset = (next.length % 6) * cascade;
    next.push({ winId, skillId, x: 80 + offset, y: 80 + offset, w: 900, h: 560, z: ++zCounter, highlightId });
    set({ windows: next });
  },
  closeWindow: (winId) => set({ windows: get().windows.filter(w => w.winId !== winId) }),
  bringToFront: (winId) => set({ windows: get().windows.map(w => w.winId === winId ? { ...w, z: ++zCounter } : w) }),
  moveWindow: (winId, x, y) => set({ windows: get().windows.map(w => w.winId === winId ? { ...w, x, y } : w) }),

  //resizeWindow: (winId, w, h) => set({ windows: get().windows.map(w => w.winId === winId ? { ...w, w, h } : w) }),
resizeWindow: (winId, width, height) =>
  set({
    windows: get().windows.map(win =>
      win.winId === winId ? { ...win, w: width, h: height } : win
    ),
  }),

  openSkillId: null,
  setOpenSkillId: (id) => set({ openSkillId: id }),

  query: '',
  setQuery: (q) => set({ query: q }),
}));

export { useSkillsStore };
export default useSkillsStore;
